import vue from '@/main'
import lodash from 'lodash'
import axios from 'axios'
import * as xlsx from 'xlsx'
import { getLocale } from '@/i18n'

/* eslint-disable no-unused-vars, no-shadow, no-eval */
const api = {
  load(processName, formName) {
    // Prefix for Cordova
    let prefix = ''
    if (window.cordova !== undefined || process.env.FRONTEND_DEV_ONLY) {
      prefix = `${process.env.APP_BASE_URL}/`
    }
    const time = new Date().getTime()
    const fetchForm = fetch(`${prefix}/static/forms/${processName}/${formName}.js?${time}`)
    const fetchStyle = fetch(`${prefix}/static/forms/${processName}/${formName}.css?${time}`)
    const fetchLocale = fetch(`${prefix}/static/forms/${processName}/${getLocale()}.json?${time}`)

    return Promise.all([fetchForm, fetchStyle, fetchLocale])
      .then(responses => responses.map(response => response.text()))
      .then(x => Promise.all(x))
      .then(([form, style, locale]) => {
        const module = {}
        // Формы собираются отдельно (build.forms.js) и объявляют эти модули external,
        // поэтому здесь их надо отдавать явно — иначе require вернёт undefined.
        function require(module) {
          return {
            vue: vue,
            lodash: lodash,
            axios: axios,
            xlsx: xlsx,
          }[module]
        }
        eval(form)
        return { obj: module.exports, style: style, locale: locale }
      })
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/component.js